"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _split_1 = require("./_split");
exports.KFold = _split_1.KFold;
exports.train_test_split = _split_1.train_test_split;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL21vZGVsX3NlbGVjdGlvbi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLG1DQUFtRDtBQUUxQyxnQkFGQSxjQUFLLENBRUE7QUFBRSwyQkFGQSx5QkFBZ0IsQ0FFQSJ9